export function getPersistData(key) {
	/*const cache =
		sessionStorage.getItem('save') == '1'
			? localStorage.getItem('app-cache')
			: null*/
	let cache: string | null = null
	try {
		cache = localStorage.getItem('app-cache')
	} catch {
		cache = null
	}
	if (cache) {
		try {
			const parsed = JSON.parse(cache)
			if (!Array.isArray(parsed)) return null
			const map = new Map(parsed)
			const data: any = map.get(key)
			if (data) {
				return data.data
			}
			return null
		} catch {
			// 손상된 캐시 복구: 삭제
			try { localStorage.removeItem('app-cache') } catch {}
			return null
		}
	} else {
		return null
	}
}
